import { SEASONAL_PLAN_CODE } from '../../../../../utils';

function getSubscriptionName(planCode: string): string {
  if (planCode === SEASONAL_PLAN_CODE) return 'Seasonal Subscription';
  return 'Annual Subscription';
}

export default getSubscriptionName;
